import React from 'react';
import { clsx } from 'clsx';

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'white';
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'medium', color = 'primary', className, ...props }, ref) => {
    const classes = clsx(
      'inline-block animate-spin rounded-full border-4 border-solid border-current border-r-transparent',
      {
        // Size variants
        'w-4 h-4': size === 'small',
        'w-8 h-8': size === 'medium',
        'w-12 h-12': size === 'large',

        // Color variants
        'text-primary': color === 'primary',
        'text-secondary': color === 'secondary',
        'text-white': color === 'white',
      },
      className
    );

    return (
      <div
        ref={ref}
        className={classes}
        role="status"
        {...props}
      >
        <span className="sr-only">Chargement...</span>
      </div>
    );
  }
);

Spinner.displayName = 'Spinner';

export default Spinner;

